
import React from 'react';
import { Link } from 'react-router-dom';

const GettingStarted: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Getting Started Today</h2>
      
      <p className="mb-5 text-gray-700 leading-relaxed">
        The journey to zero-trust security is best approached as an evolution, not a revolution. Here are three concrete steps you can take this week:
      </p>
      
      <ol className="mb-6">
        <li className="mb-4 pb-4 border-b border-gray-100">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">1. Conduct an access audit</h4>
          <p className="text-gray-700">
            Document who has access to what systems and data in your organization. This creates a baseline for implementing 
            better controls. Our <Link to="/services/it-support" className="text-itmgmt-medium-blue">managed IT services</Link> include comprehensive security audits.
          </p>
        </li>
        <li className="mb-4 pb-4 border-b border-gray-100">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">2. Enable MFA everywhere possible</h4>
          <p className="text-gray-700">
            Start with your most critical systems (email, financial platforms, customer databases). This single step can prevent the vast majority of account compromise attacks.
          </p>
        </li>
        <li className="mb-4">
          <h4 className="font-bold text-itmgmt-dark-blue mb-2">3. Develop an incident response plan</h4>
          <p className="text-gray-700">
            Document the steps you'll take if a security breach occurs. Having a clear plan reduces panic and improves recovery times.
          </p>
        </li>
      </ol>
      
      <p className="mb-6 text-gray-700 leading-relaxed">
        Remember, perfect security is impossible, but zero-trust principles dramatically reduce your risk surface and limit the damage from inevitable attempts.
      </p>
    </>
  );
};

export default GettingStarted;
